import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import ver from './version.json';
import ztr from 'zod-i18n-map/locales/tr/zod.json';
import { zodI18nMap } from 'zod-i18n-map';
import { z } from 'zod';

i18n
  .use(Backend)
  //.use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'tr',
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + ver.version,
    },
    keySeparator: '.',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    supportedLngs: ['tr', 'en'],
  });

// load zod message translations
i18n.addResourceBundle('tr', 'zod', ztr);

// register i18n instance to zod-i18n-map
z.setErrorMap(zodI18nMap);

export { z };
